export default function isAuth({next, store}) {
    if (!store.state.loggedUser) {
        return next({
            name: '/'
        })
    }
}